module.exports = __webpack_public_path__ + "static/media/icn-campaigns.bd0461f0.svg";